/**
 * Flatten a Strong's definition to plain text for places that render it as a
 * string (chip popover preview). The source carries <A>/<B>/<I>/<U> markup —
 * keep the inner text, drop the tags, collapse the hard-wrapped newlines.
 */
export function definitionPlainText(definition: string): string {
  return definition
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}
